import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tempallocation-list',
  templateUrl: './tempallocation-list.component.html',
  styleUrls: ['./tempallocation-list.component.css']
})
export class TempallocationListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
